import Markdown from '@wandb/weave/common/components/Markdown';
import {Alert} from '@wandb/weave/components/Alert';
import {LoadingDots} from '@wandb/weave/components/LoadingDots';
import {useWFHooks} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/context';
import React from 'react';

import {ContentViewMetadataLoadedProps} from './types';

export const MarkdownContent = (props: ContentViewMetadataLoadedProps) => {
  const {useFileContent} = useWFHooks();
  const {entity, project, content} = props;
  const fileContent = useFileContent({
    entity,
    project,
    digest: content,
  });
  if (fileContent.loading) {
    return <LoadingDots />;
  }
  if (fileContent.result == null) {
    return <Alert severity="error"> Error loading content </Alert>;
  }
  const decoder = new TextDecoder();
  const markdownContent = decoder.decode(fileContent.result);
  return <Markdown content={markdownContent} />;
};
